import styled from 'styled-components';

import {BackTo} from 'components/common/BackTo';
import {ContentContainer} from 'components/ui-kit/PageComponents';
import {breakpoint, colors} from 'theme';

export const StyledContentContainer = styled(ContentContainer)`
    flex: 1 1 auto;
    padding-bottom: 0;
`;

export const StyledBackTo = styled(BackTo)`
    margin-left: 0;
`;

export const Typography = styled.div`
    font-size: 14px;
    line-height: 26px;
    letter-spacing: 0.1px;
    word-wrap: break-word;
`;

export const TitleWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 20px;
    align-items: center;
    margin: 20px 0 36px 0;
`;

export const Title = styled(Typography)`
    text-transform: uppercase;
    font-size: 25px;
    font-weight: 700;
`;

export const GraphWrapper = styled.div`
    width: calc(100% + 30px);
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    margin-left: -15px;
    border-top: 1px solid ${colors.textMuted};

    @media (min-width: ${breakpoint.tablet}) {
        width: calc(100% + 60px);
        margin-left: -30px;
    }
`;

export const GraphContainer = styled(ContentContainer)`
    padding: 0;
`;
